export default class AlertService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getAlerts() {
    return this.$http.get('/api/alert/load_alert');
  }
}



// WEBPACK FOOTER //
// ./services/alert.service.js